import { Button } from "primereact/button";
import { useEffect } from "react";
import { useNavigate } from "react-router";
/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */

const SignInSignOut = () => {
  const navigate = useNavigate();

  // button animation
  useEffect(() => {
    const element = document.getElementById("bg-animation");
    if (element) {
      element.classList.add("bg-animate");
    }
  }, []);

  return (
    <>
      <div id="bg-animation">
        <div className="full-screen-container ">
          <div className="image-container text-white">
            <div className="image-home"></div>
          </div>
          <div className="flex">
            <div className="flex flex-col justify-center items-center w-full">
              <div>
                {" "}
                <h1 className="text-purple">Kindergarten Inclusion Support Program</h1>
                <p className="mx-8 my-5 text-left">
                  The KIS Program Application Service is operated by{" "}
                  <a href="https://www.aha.com.au" target="_blank" rel="noopener noreferrer" aria-label="AHA (opens in a new tab)">
                    <strong>AHA</strong>
                  </a>
                  , on behalf of the Victorian Department of Education.
                  <br />
                  <br />
                  Kindergartens can submit a KIS application by signing into the KIS portal and submitting an online application. Click on the{" "}
                  <strong>KIS Portal</strong> button below to sign up or sign in to the portal.
                  <br />
                  <br />
                  Further information about the KIS program, including application guidelines and forms, can be found on the{" "}
                  <a
                    href="https://www.vic.gov.au/kindergarten-inclusion-children-disabilities"
                    target="_blank"
                    title="Link opens in a new tab"
                    rel="noreferrer">
                    Department's website
                  </a>
                  . <i aria-hidden="true" className="pi pi-external-link"></i>
                  <br />
                  <br />
                  Additional resources to assist kindergartens to sign in to the portal and complete an online application can be found by clicking on
                  the <strong>KIS Resources</strong> button below.
                  <br />
                  <br />
                  <strong>
                    Prior to continuing, you must read our Privacy Notice, which is available&nbsp;
                    <a href="https://www.ahaconsulting.com.au/wp-content/uploads/2025/10/KIS-Privacy-Notice.pdf" rel="noreferrer">
                      here
                    </a>
                  </strong>
                  .{" "}
                </p>{" "}
                <p className="mx-8 my-5">
                  <div className="flex flex-wrap gap-5">
                    <Button
                      className="filled-round-button landing mr-5 mt-2 mb-2 h-50 whitespace-nowrap"
                      label="KIS Resources"
                      onClick={() => navigate("/resources")}
                      icon="pi pi-book text-2xl"></Button>
                    <Button
                      className="filled-round-button-secondary landing mt-2 mb-2 h-50 whitespace-nowrap"
                      label="KIS Portal"
                      onClick={() => navigate("/login")}
                      icon="pi pi-desktop text-2xl"></Button>
                  </div>
                </p>
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>
      </div>{" "}
    </>
  );
};

export const LandingPage = (props: { children: any }) => {
  return (
    <div>
      <SignInSignOut />
      {props.children}
    </div>
  );
};
